import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApAccordionModule } from '@ap/accordion';
import { ApAnalyticsModule } from '@ap/analytics';
import { ApButtonComponent } from '@ap/button';
import { ApContentModule } from '@ap/content';
import { ApExplanationComponent } from '@ap/explanation';
import { ApIllustrationComponent } from '@ap/illustration';
import { ApInputComponent } from '@ap/input';
import { SessiebeheerModule } from '@ap/interface-apic-sessiebeheer';
import { ApKeyValueModule } from '@ap/key-value';
import { ApNotificationComponent } from '@ap/notification';
import { ApSpinnerComponent } from '@ap/spinner';
import { ApTextareaComponent } from '@ap/textarea';

import { MijnAnalyseDirective } from './mijn-analyse.directive';
import { MijnAnalyseModalComponent } from './modal/mijn-analyse.modal.component';

/**
 * @name MijnAnalyseModule
 * @ngdoc module
 */
@NgModule({
    imports: [
        ApButtonComponent,
        ApContentModule,
        ApIllustrationComponent,
        ApInputComponent,
        CommonModule,
        ReactiveFormsModule,
        ApTextareaComponent,
        ApKeyValueModule,
        ApNotificationComponent,
        ApAccordionModule,
        ApExplanationComponent,
        ApSpinnerComponent,
        SessiebeheerModule,
        ApAnalyticsModule
    ],
    exports: [MijnAnalyseDirective],
    declarations: [MijnAnalyseDirective, MijnAnalyseModalComponent]
})
export class MijnAnalyseModule {}
